import { render, staticRenderFns } from "./TheTableOrders.vue?vue&type=template&id=02de2792&scoped=true&"
import script from "./TheTableOrders.vue?vue&type=script&lang=ts&"
export * from "./TheTableOrders.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02de2792",
  null
  
)

export default component.exports